<template>
  <div class="truncate" :class="$attrs.class" v-html="value" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AmountFormatter',
  props: {
    amount: {
      type: [Number, String],
      required: true
    },
    classes: {
      type: String,
      required: false,
      default: ''
    },
    currency: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      currencySettings: 'metadata/getDefaultCurrencyMetadata'
    }),
    defaultCurrency() {
      return this.currency ?? this.currencySettings
    },
    value() {
      if (this.amount === null || this.amount === '#######') {
        return ''
      }
      return this.$h.formatCurrency(this.amount, this.defaultCurrency)
    }
  }
}
</script>

<style scoped></style>
